import {BmEnvironmentType} from './bm-environment-type';

export const environment: BmEnvironmentType = {
  environmentName: 'production',
  production: true,
  apiUrl: '/',
  intercomSettings: {
    appId: '5qur5uee',
    enabled: true
  },
  authorizedLink: '/n/activity',
  stripeCredentials: {
    key: 'pk_live_51A2jmtDEQRnbGAD9jHuVDk7tu1cOqf7iiHHnY4PwGRFE6yp6thmmA46xPOB9WADT1LInoxhmaLLZFYEeAR7S9IWh00g2BhMQpP'
  },
  notificationsRequestIntervalEnabled: true,
  enableRemoteLogging: true,
  logRocketKey: 'dnd3qt/barnmanager',
  enableSignUp: false
};
